document.querySelectorAll('.js-pdp-fixed').forEach($fixed => {
    if (window.innerWidth <= 7608) {
        const $order = document.querySelector('.product-info-container');
        const $submitButton = document.querySelector('.product-form-submit');

        if ($order) {
            const scrollTop = $order.offsetTop + $order.offsetHeight;

            window.addEventListener('scroll', () => {
                if (window.scrollY >= scrollTop) {
                    $fixed.classList.add('active');
                } else {
                    $fixed.classList.remove('active');
                }

                const buttonRect = $submitButton.getBoundingClientRect();

                // Check if button is in viewport
                const isInView = (
                    buttonRect.top >= 0 &&
                    buttonRect.left >= 0 &&
                    buttonRect.bottom <= (window.innerHeight + 50) &&
                    buttonRect.right <= window.innerWidth
                );

                // Toggle class based on visibility
                if (isInView) {
                    $fixed.classList.add('opacity-0', 'pointer-events-none');
                } else {
                    $fixed.classList.remove('opacity-0', 'pointer-events-none');
                }
            });
        }
    }
    // else {
    //     const $order = document.querySelector('.js-pdp-order-desktop').querySelector('.js-order-button');
    //
    //     if ($order) {
    //         let scrollTop = 0;
    //
    //         window.addEventListener('scroll', () => {
    //             scrollTop = $order.getBoundingClientRect().top + $order.offsetHeight;
    //
    //             if (scrollTop < 0) {
    //                 $fixed.classList.add('active');
    //             } else {
    //                 $fixed.classList.remove('active');
    //             }
    //         });
    //     }
    // }
});